import request from "root/js/request";

export const getParserKeywordsClusterGroupsV2 = async ({
  limit,
  offset,
  keywords,
  clusters,
  stop_search,
  stop_keywords,
  stop_clusters,
  ...rest
}) => {
  const response = await request({
    url: `/parsers/keywords_cluster/groups_v2/`,
    method: "GET",
    params: {
      limit,
      offset,
      keywords,
      clusters,
      stop_search,
      stop_keywords,
      stop_clusters,
      ...rest,
    },
  });
  return response.data;
};


export const postParserKeywordsClusterGroupsV2 = async ({
  limit,
  offset,
  keywords,
  clusters,
  stop_search,
  stop_keywords,
  stop_clusters,
  search,
  ...rest
}) => {
  const response = await request({
    url: `/parsers/keywords_cluster/groups_v2/`,
    method: "POST",
    params: {
      limit,
      offset,
      keywords,
      clusters,
      stop_search,
      stop_keywords,
      stop_clusters,
      ...rest,
    },
    data: {search: search}
  });
  return response.data;
};